// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'vue-material/dist/components/mdCore/index.css'
import 'vue-material/dist/components/mdAvatar/index.css'
import 'vue-material/dist/components/mdButton/index.css'
import 'vue-material/dist/components/mdCard/index.css'
import 'vue-material/dist/components/mdCheckbox/index.css'
import 'vue-material/dist/components/mdChips/index.css'
import 'vue-material/dist/components/mdDialog/index.css'
import 'vue-material/dist/components/mdFile/index.css'
import 'vue-material/dist/components/mdIcon/index.css'
import 'vue-material/dist/components/mdInputContainer/index.css'
import 'vue-material/dist/components/mdList/index.css'
import 'vue-material/dist/components/mdMenu/index.css'
import 'vue-material/dist/components/mdProgress/index.css'
import 'vue-material/dist/components/mdRadio/index.css'
import 'vue-material/dist/components/mdSelect/index.css'
import 'vue-material/dist/components/mdSidenav/index.css'
import 'vue-material/dist/components/mdSnackbar/index.css'
import 'vue-material/dist/components/mdSpinner/index.css'
import 'vue-material/dist/components/mdStepper/index.css'
import 'vue-material/dist/components/mdSubheader/index.css'
import 'vue-material/dist/components/mdTable/index.css'
import 'vue-material/dist/components/mdToolbar/index.css'
import 'vue-material/dist/components/mdTooltip/index.css'
import 'vue-material/dist/components/mdDivider/index.css'
import 'vue-material/dist/components/mdBackdrop/index.css'
import 'vue-material/dist/components/mdLayout/index.css'
import 'vue-material/dist/components/mdWhiteframe/index.css'
import 'vue-datetime/dist/vue-datetime.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'tour/dist/tour.css'

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'
import VeeValidate from 'vee-validate'
import VueMaterial from 'vue-material'
import dictionary from './i18n/vee'
import VueEvents from 'vue-events'
import VueChartist from 'vue-chartist'
import './fonts/material-icons/material-icons.css'
import './fonts/roboto/roboto.css'
import './stylesheets/chartist.css'
import Datetime from 'vue-datetime'
import PageContent from '@/components/page-content'
import Sidenav from '@/components/sidenav'
import { STEP_TYPES, TRANSITIONS, WAIT_TIME_LIMIT, RETRY_TIME_LIMIT, getConfig, getLogo } from './config'
import moment from 'moment'
import VueTruncate from 'vue-truncate-filter'
import Popover from 'vue-js-popover'
import {default as axiosRetry, isSafeRequestError} from 'axios-retry'
import * as types from './store/mutation-types'

// install globally
Vue.use(VueMaterial.MdCore)
Vue.use(VueMaterial.MdAvatar)
Vue.use(VueMaterial.MdButton)
Vue.use(VueMaterial.MdCard)
Vue.use(VueMaterial.MdCheckbox)
Vue.use(VueMaterial.MdChips)
Vue.use(VueMaterial.MdDialog)
Vue.use(VueMaterial.MdFile)
Vue.use(VueMaterial.MdIcon)
Vue.use(VueMaterial.MdInputContainer)
Vue.use(VueMaterial.MdList)
Vue.use(VueMaterial.MdMenu)
Vue.use(VueMaterial.MdProgress)
Vue.use(VueMaterial.MdRadio)
Vue.use(VueMaterial.MdSelect)
Vue.use(VueMaterial.MdSidenav)
Vue.use(VueMaterial.MdSnackbar)
Vue.use(VueMaterial.MdSpinner)
Vue.use(VueMaterial.MdStepper)
Vue.use(VueMaterial.MdSubheader)
Vue.use(VueMaterial.MdTable)
Vue.use(VueMaterial.MdToolbar)
Vue.use(VueMaterial.MdTooltip)
Vue.use(VueMaterial.MdDivider)
Vue.use(VueMaterial.MdBackdrop)
Vue.use(VueMaterial.MdLayout)
Vue.use(VueMaterial.MdWhiteframe)

Vue.use(Popover)
Vue.use(Datetime)
Vue.use(VueTruncate)
Vue.use(VueEvents)
Vue.use(VueChartist)
Vue.use(VeeValidate, {
  locale: 'es',
  dictionary
})

Vue.material.registerTheme({
  global: {
    primary: {
      color: 'blue',
      hue: '600'
    },
    accent: 'deep-orange',
    warn: 'deep-orange',
    background: 'white'
  },
  white: {
    primary: 'white',
    accent: 'blue'
  },
  'light-blue': {
    primary: 'light-blue'
  }
})

Vue.component('page-content', PageContent)
Vue.component('sidenav', Sidenav)

Vue.config.productionTip = false

Vue.prototype.STEP_TYPES = STEP_TYPES
Vue.prototype.TRANSITIONS = TRANSITIONS
Vue.prototype.WAIT_TIME_LIMIT = WAIT_TIME_LIMIT
Vue.prototype.RETRY_TIME_LIMIT = RETRY_TIME_LIMIT

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY hh:mm')
  }
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.directive('enable-if-roles', {
  inserted (el, binding, vnode) {
    el.disabled = !vnode.context.$store.getters.hasRoles(binding.value)
  }
})

Vue.directive('show-if-roles', {
  inserted (el, binding, vnode) {
    const cond = vnode.context.$store.getters.hasRoles(binding.value)
    cond ? el.style.visibility = 'visible' : el.style.visibility = 'hidden'
  }
})

axiosRetry(axios, {retries: 5,
  retryDelay (count) {
    return Math.pow(2, count) * 500
  },
  retryCondition: isSafeRequestError
})

Promise.all([
  getConfig(),
  getLogo()
]).then(([config, logo]) => {
  store.commit(types.SET_GLOBAL_LOGO, logo)
  store.commit(types.SET_GLOBAL_TITLE, config.softwareTitle)
  const backendUrl = config.backendBaseURL
  axios.defaults.baseURL = backendUrl
  Vue.prototype.$backendBaseURL = backendUrl
  Vue.prototype.$wsBaseUrl = config.wsBaseURL
  Vue.prototype.$softwareTitle = config.softwareTitle
  Vue.prototype.$logoCompany = logo
  const app = new Vue({
    el: '#app',
    router,
    store,
    i18n,
    template: '<App/>',
    components: { App }
  })

  router.beforeEach((to, from, next) => {
    Vue.nextTick(() => {
      let mainContent = document.querySelector('.main-content')

      if (mainContent) {
        mainContent.scrollTop = 0
      }
      app.$events.$emit('closeSidenav')
      next()
    })
  })
}).catch(() => {
  new Vue({ //eslint-disable-line
    el: '#app',
    template: '<p>Error General</p>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js